export default __webpack_public_path__ + "800d7c8e9e5b9a4a94c6ce9a1824a64f.svg";